import React from 'react';
import { Container, Typography, Grid, Card, CardContent, Button, Box, LinearProgress, Avatar } from '@mui/material';
import { PieChart, ArrowBack, MilitaryTech, Psychology, School, LocalActivity } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StudentTacticalOverview: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Button startIcon={<ArrowBack />} onClick={() => navigate('/student-dashboard')} sx={{ mb: 3 }}>
                Back to Dashboard
            </Button>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                <PieChart sx={{ fontSize: 40, color: '#2ecc71' }} />
                <Typography variant="h4" fontWeight="bold">Tactical Overview</Typography>
            </Box>

            <Grid container spacing={4}>
                {/* Badges Section */}
                <Grid item xs={12} md={6}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>Pending Rewards</Typography>
                    <Card sx={{ bgcolor: '#f1f2f6', borderRadius: 4, border: 'none', boxShadow: 0, mb: 2 }}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                <MilitaryTech sx={{ fontSize: 60, color: '#ffa502' }} />
                            </Box>
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Battle Badge Pending</Typography>
                                <Typography variant="body2" color="text.secondary">You are 1 quiz away from "Sharpshooter".</Typography>
                            </Box>
                            <Button variant="outlined" size="small" sx={{ ml: 'auto', borderRadius: 2 }}>Claim</Button>
                        </CardContent>
                    </Card>
                    <Card sx={{ bgcolor: '#f1f2f6', borderRadius: 4, border: 'none', boxShadow: 0 }}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                <LocalActivity sx={{ fontSize: 60, color: '#a29bfe' }} />
                            </Box>
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Weekly Streak</Typography>
                                <Typography variant="body2" color="text.secondary">Login 2 more days to reach 7-day streak.</Typography>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Peer Support Section */}
                <Grid item xs={12} md={6}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>Community Operations</Typography>
                    <Card sx={{ bgcolor: '#f1f2f6', borderRadius: 4, border: 'none', boxShadow: 0, mb: 2 }}>
                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                <Psychology sx={{ fontSize: 60, color: '#3742fa' }} />
                            </Box>
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Peer Support Needed</Typography>
                                <Typography variant="body2" color="text.secondary">2 questions in Physics need your help.</Typography>
                            </Box>
                            <Button variant="contained" size="small" sx={{ ml: 'auto', borderRadius: 2 }}>Assist</Button>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Skill Stats */}
                <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mt: 2 }}>Skill Proficiency</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ p: 2, borderRadius: 4 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                    <Avatar sx={{ bgcolor: 'primary.light' }}><School /></Avatar>
                                    <Typography fontWeight="bold">Mathematics</Typography>
                                </Box>
                                <LinearProgress variant="determinate" value={75} sx={{ height: 10, borderRadius: 5, mb: 1 }} />
                                <Typography variant="caption" color="text.secondary">Level 5 Mastery</Typography>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Card sx={{ p: 2, borderRadius: 4 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                    <Avatar sx={{ bgcolor: 'secondary.light' }}><School /></Avatar>
                                    <Typography fontWeight="bold">Physics</Typography>
                                </Box>
                                <LinearProgress variant="determinate" value={45} color="secondary" sx={{ height: 10, borderRadius: 5, mb: 1 }} />
                                <Typography variant="caption" color="text.secondary">Level 3 Mastery</Typography>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
};

export default StudentTacticalOverview;
